import { validateEmailRegEx } from '@constants'


export const isObject = <Object extends Record<string, any>>(value: unknown): value is Object => (!!value && typeof value === 'object' && !Array.isArray(value))
export const isNonEmptyObject = <Object extends Record<string, any>>(value: unknown): value is Object => (isObject(value) && Object.keys(value).length > 0)

export const isArray = <Item = unknown>(value: unknown): value is Array<Item> => (!!value && Array.isArray(value))
export const isNonEmptyArray = <Item = unknown>(value: unknown): value is Array<Item> => (isArray(value) && value.length > 0)

export const isNumber = (value: unknown): value is number => (typeof value === 'number' && !isNaN(value))

export const isString = (value: unknown): value is string => (typeof value === 'string')
export const isNonEmptyString = (value: unknown): value is string => (isString(value) && !!value)

export const isEmail = (value: unknown): value is `${string}@${string}.${string}` => (isNonEmptyString(value) && validateEmailRegEx.test(value))

export const isDate = (value: unknown): value is Date => (!!value && value instanceof Date && !isNaN(value as any))